var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// AUTO-GENERATED CONTENT - DO NOT MANUALLY EDIT - Run 'yarn generate:icons' to update
import Icon from '../icon-internal';
function Code(_a) {
    var size = _a.size, restProps = __rest(_a, ["size"]);
    return (_jsx(Icon, __assign({ viewBox: "0 0 18 18", size: size }, restProps, { children: _jsx("path", { fill: "currentColor", d: "m17.655 9.756-4.946 4.95a1 1 0 1 1-1.415-1.415l4.29-4.294-4.277-4.293a.998.998 0 0 1 .003-1.413 1 1 0 0 1 1.414.003l4.985 5.002a.998.998 0 0 1-.054 1.46Zm-17.31 0a.998.998 0 0 1-.054-1.46l4.985-5.002a1 1 0 0 1 1.414-.003.998.998 0 0 1 .003 1.413L2.416 8.997l4.29 4.294a1.002 1.002 0 0 1-1.415 1.416L.345 9.757Z" }) })));
}
export default Code;
